import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppHeader from "../../components/layout/components/AppHeader";
import AppFooter from "../../components/layout/components/footer/AppFooter";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import AppAnimate from "../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import {defaultVariables} from "../../../config";
import {Home} from "lucide-react";
import Container from "@mui/material/Container";
import Title from "../../components/elements/Title";


function Layout({classes,error = 404}) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <CssBaseline />
            <AppHeader />
            <main className={classes.layoutMain}>
                <div className={'front-layout error-page'}>
                    <AppAnimate animation='transition.slideUpIn' delay={200} title={ error === 404 ? t('nothingFound') : t('somethingWrongHappends')}>
                        <Container maxWidth="xl">
                            <Grid container spacing={2}>
                                <Grid item size={12} style={{textAlign:"center"}}>
                                    <Title>{error === 404 ? t('nothingFound') : t('somethingWrongHappends')}</Title>
                                    <Typography className="mb-30">{error === 404 ? t('nothingFoundDesc') : t('somethingWrongHappendsDesc')}</Typography>
                                    <Button
                                        component="a"
                                        href={defaultVariables.website}
                                        variant="contained"
                                        startIcon={<Home className="lucide-icon"/>}
                                    >
                                        {t('backToHome')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Container>
                    </AppAnimate>
                </div>
            </main>
            <AppFooter />
        </React.Fragment>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(Layout);
